import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import {
    TrapIcon1,
    TrapIcon2,
    TrapIcon3,
    TrapIcon4,
    TrapIcon5,
    TrapIcon6,
    TrapIconUnnamed,
} from 'src/domains/sportsbook/webview/components/trap/TrapIcons';
import { SvgIconPropsType } from 'src/ui/assets/icons/utils';

type TrapIconsType = {
    [key: string]: React.FC<SvgIconPropsType>;
    unnamed: React.FC<SvgIconPropsType>;
};

export const TrapIcons: TrapIconsType = {
    '1': TrapIcon1,
    '2': TrapIcon2,
    '3': TrapIcon3,
    '4': TrapIcon4,
    '5': TrapIcon5,
    '6': TrapIcon6,
    unnamed: TrapIconUnnamed,
};

interface PropsType {
    className?: string;
    trapNumber: string | number | undefined | null;
    selectionId: SelectionId | null;
}

export const Trap = observer('Trap', ({ trapNumber, className, selectionId }: PropsType) => {
    const selectionModel = selectionId?.getModel() ?? null;
    const eventModel = selectionModel?.getEvent() ?? null;
    const marketModel = selectionModel?.getMarket() ?? null;

    const isInternationalGreyhoundRacing = eventModel?.sportOriginal === 'internationalgreyhoundracing';

    if (trapNumber === undefined && marketModel !== null && selectionId !== null) {
        const order = marketModel.selectionsIds.indexOf(selectionId.toOldId()) + 1;

        trapNumber = order;
    }

    if (
        (typeof trapNumber === 'string' || typeof trapNumber === 'number') &&
        isInternationalGreyhoundRacing === false
    ) {
        const key = String(trapNumber);
        const TrapIcon = TrapIcons[key] ?? TrapIcons.unnamed;

        return <TrapIcon className={className} />;
    }

    return null;
});
